import { render, staticRenderFns } from "./PredictWinner.vue?vue&type=template&id=7418ec82&scoped=true&"
import script from "./PredictWinner.vue?vue&type=script&lang=js&"
export * from "./PredictWinner.vue?vue&type=script&lang=js&"
import style0 from "./PredictWinner.vue?vue&type=style&index=0&id=7418ec82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7418ec82",
  null
  
)

export default component.exports